window.addEventListener("DOMContentLoaded", () => {
	const loadMore = document.querySelector('.news-module .load-more')
    if(loadMore){
        loadMore.addEventListener('click', ()=>{
            const hiddenItems = document.querySelectorAll('.news-module .item.hidden')
            let existHiddentItem = false
            const hiddenItemNumber = hiddenItems.length
            let index = 0
            hiddenItems.forEach(item =>{
                if(index > 3){
                    existHiddentItem = true
                    return
                }
                item.classList.remove('hidden')
                index ++;
            })
            if(!existHiddentItem){
                loadMore.classList.add('hidden')
            }

        })
    }
});